
const {reactive , watch, onMounted} = Vue
import Comment from '@/commonjs/class/Comment.js'

jdw.vuex.Comments = {}
jdw.vuex.Comments.components = {}

if (jdw.isMob()) {
    const { Popup, Field, Dialog, Switch } = vant    
    jdw.vuex.Comments.components[Dialog.name] = Dialog
    jdw.vuex.Comments.components[Popup.name] = Popup
    jdw.vuex.Comments.components[Field.name] = Field
    jdw.vuex.Comments.components[Switch.name] = Switch
}else{
    const { ElButton,ElInput,ElDialog,ElFormItem,ElSwitch } = ElementPlus
    jdw.vuex.Comments.components.ElButton = ElButton
    jdw.vuex.Comments.components.ElInput = ElInput
    jdw.vuex.Comments.components.ElDialog = ElDialog
    jdw.vuex.Comments.components.ElFormItem = ElFormItem
    jdw.vuex.Comments.components.ElSwitch = ElSwitch
}

const Comments = {
    name: "Comments",
    components: jdw.vuex.Comments.components,
    setup(props, context) {
        //let pagination = new Pagination()
        const data = reactive({
            url: '',
            comments: [],
            add_com:{
                url: '',             //评论添加地址
                com_type:   'com',     //rep | com
                title:      '评论',  //评论 | 回复
                com_id:     -1,     //com_id因关联页面渲染，保持不变
                rep_id:     -1,     //rep_id，回复id，新添加属性
                show_panel: false,
                com_text:   '',
                group: 1,          //1:支持；-1:反对
                support: true,          //1:支持；0:反对
                support_text: '支持',
                rep_content: '回复文本'
            },
            like_com:{
                id:'',
                url:'',
            },
            page:{
                type: '',
                id: '',
            },
            sort_num: -1,
            is_reverse: true,
            reverse_num: 100000,
            //pagination: pagination
        })
        watch(() => data.add_com.support , (newValue, oldValue) => {
            //console.log(newValue)
            let support_texts = ['反对','支持']
            data.add_com.support_text = support_texts[Number(newValue)]
            let groups = [-1,1]
            data.add_com.group = groups[Number(newValue)]
        })
        watch(() => data.page.id , (newValue, oldValue) => {
            setUrl()
        })
        watch(() => data.like_com.id , (newValue, oldValue) => {
            setLikeUrl(newValue)
        })
        watch(() => data.is_reverse , (newValue, oldValue) => {
            reverseComments()
        })
        onMounted(()=>{
            initComponent()
            setUrl()
            getComments()
        })
        return {
            data,
            repComment,
            addComment,
            sendComment,
            likeComment,
            reverseComments
        }
        function initComponent(){
            let params = $('#app-data').data('params')
            data.page.type   = params.type
            data.page.id     = params.id
            if(params.type == 'entry-guess')             data.page.type = 'guess'
        }
        function sendComment(){
            if(jdw.isShake())           return
            if(data.add_com.com_text.trim().length < 1){
                layer.msg("评论不能为空")
                return;
            }
            let sendJson = {
                comment: data.add_com.com_text,
                group: data.add_com.group,
                type: data.add_com.com_type,
            }
            if(data.add_com.com_id > 0)     sendJson.com_id = data.add_com.rep_id
            $.ajax({
                url: data.add_com.url ,
                type: "post",
                dataType: "json",
                cache: false,
                data: sendJson,
                success: function(ret){
                    data.add_com.show_panel = false
                    data.add_com.com_id = -1;
                    layer.msg("发表评论成功");
                    data.add_com.com_text = ''
                    getComments(1);
                },
                error: function(err){
                    data.add_com.com_id = -1;
                    layer.msg('发生未知错误');
                }
            });
        }
        function getComments(page = 1){
            jdw.request({
                url:  data.url + '?page=' + page,
                type: "get",
                dataType: "json",
                cache: true,
            }).then(res=>{
                let comments = jdw.getAjaxData(res)

                let fatherComments = {};

                for (var i = 0; i < comments.length; i++) {
                    //com_id 为null，是直接评论，先构建出来
                    if (!comments[i]["com_id"]) {
                        //以comments的id属性作为key
                        fatherComments[comments[i]["id"]] = new Comment(comments[i]);
                    }
                }
                for (var i = comments.length - 1; i >= 0; i--) {
                    if (comments[i]["com_id"] && fatherComments[comments[i]["com_id"]]) {
                        var sonComment = new Comment(comments[i]);
                        fatherComments[comments[i]["com_id"]].sonComment[sonComment.id] = sonComment;
                    }
                }
                if(data.is_reverse)             reverseComments(fatherComments)
                else                            data.comments = fatherComments
            }).catch(err=>{
                console.error(err)
            })
        }
        
        //评论点赞
        function likeComment(e){
            if(jdw.isShake())           return
            let id = e.target.dataset.id
            data.like_com.id = id
            setLikeUrl(id)
            $.ajax({
                url: data.like_com.url,
                type: "post",
                dataType: "json",
                cache: true,
                data: {
                },
                success: function(res){
                    let comid = e.target.dataset.comid
                    if (comid) {
                        if(data.is_reverse)        comid = data.reverse_num - comid
                        data.comments[comid].sonComment[id].is_follow += Number(res.data);
                        data.comments[comid].sonComment[id].follow += Number(res.data);
                    }else{
                        if(data.is_reverse)        id = data.reverse_num - id
                        data.comments[id].is_follow += Number(res.data);
                        data.comments[id].follow += Number(res.data);
                    }
                },
                error: function(err){
                    layer.msg('发生未知错误')
                }
            });
        }
        
        function reverseComments(obj) {
            console.log(data.is_reverse)
            obj = obj || data.comments
            let temp_obj = {}
            Object.keys(obj).forEach( key => {
                temp_obj[data.reverse_num - key] = obj[key]
            })
            data.comments = temp_obj
            if(data.add_com.com_id > 0)     data.add_com.com_id = data.reverse_num - data.add_com.com_id
            return temp_obj
        }

        //添加评论
        function addComment(e){
            if(jdw.isShake())           return
            //console.log(e)
            data.add_com.title = '评论'
            data.add_com.com_id = -1
            data.add_com.rep_id = -1
            data.add_com.com_type = 'com'     //rep | com
            data.add_com.show_panel = true
        }

        function repComment(e){
            if(jdw.isShake())           return
            let com_id = e.target.dataset.id
            if(data.is_reverse)     data.add_com.com_id = data.reverse_num - com_id
            else                    data.add_com.com_id = com_id
            data.add_com.rep_id = com_id
            data.add_com.title = '回复@' + e.target.dataset.id
            data.add_com.com_type = 'rep'     //rep | com
            data.add_com.show_panel = true
        }
        function setUrl()
        {
            //console.log(data.page)
            let comments_urls = {
                item: '/tree/' + data.page.id + '/coms',
                event: '/event/' + data.page.id + '/coms',
                guess: '/entryguess/comments/' + data.page.id,
                question: '/subject/' + data.page.id + '/coms',
                contact:'/web/coms',
            }
            let comment_urls = {
                item: "/tree/" + data.page.id + "/comment",
                event: "/event/" + data.page.id + "/comment",
                guess: '/entryguess/comment/' + data.page.id,
                question: '/subject/' + data.page.id + '/comment',
                contact: '/web/comment',
            }
            data.url = comments_urls[data.page.type]
            data.add_com.url = comment_urls[data.page.type]
        }
        function setLikeUrl(com_id)
        {
            com_id = com_id || data.like_com.id
            let like_urls = {
                item: "/tree/comfollow/" + com_id,
                event: "/event/comfollow/" + com_id,
                guess: '/entryguess/comfollow/' + com_id,
                question: "/subject/comfollow/" + com_id,
                contact: '/web/comfollow/' + com_id,
            }
            data.like_com.url = like_urls[data.page.type]
        }
    }
}
jdw.components.Comments = Comments
//导出本地类
export default Comments